/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type ShareContactQueryVariables = {
    contactSlug: string;
    searchQuery?: string | null;
    role?: string | null;
};
export type ShareContactQueryResponse = {
    readonly sharedContacts: ReadonlyArray<{
        readonly slug: string;
        readonly name: string;
        readonly shared: boolean;
    }>;
};
export type ShareContactQuery = {
    readonly response: ShareContactQueryResponse;
    readonly variables: ShareContactQueryVariables;
};



/*
query ShareContactQuery(
  $contactSlug: String!
  $searchQuery: String
  $role: String
) {
  sharedContacts(searchQuery: $searchQuery, role: $role, contactSlug: $contactSlug) {
    slug
    name
    shared(contactSlug: $contactSlug)
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contactSlug"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "role"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchQuery"
},
v3 = {
  "kind": "Variable",
  "name": "contactSlug",
  "variableName": "contactSlug"
},
v4 = [
  {
    "alias": null,
    "args": [
      (v3/*: any*/),
      {
        "kind": "Variable",
        "name": "role",
        "variableName": "role"
      },
      {
        "kind": "Variable",
        "name": "searchQuery",
        "variableName": "searchQuery"
      }
    ],
    "concreteType": "SharedContact",
    "kind": "LinkedField",
    "name": "sharedContacts",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          (v3/*: any*/)
        ],
        "kind": "ScalarField",
        "name": "shared",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ShareContactQuery",
    "selections": (v4/*: any*/),
    "type": "ApplicationQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "ShareContactQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "8c88974b4c335fa73b4dec486dde6fdb",
    "id": null,
    "metadata": {},
    "name": "ShareContactQuery",
    "operationKind": "query",
    "text": "query ShareContactQuery(\n  $contactSlug: String!\n  $searchQuery: String\n  $role: String\n) {\n  sharedContacts(searchQuery: $searchQuery, role: $role, contactSlug: $contactSlug) {\n    slug\n    name\n    shared(contactSlug: $contactSlug)\n  }\n}\n"
  }
};
})();
(node as any).hash = '015ac94af030fb63faa67f4537952a75';
export default node;
